var _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _text22, _text23, _text24, _text25, _text26, _text27, _text28, _text29, _text30, _text31, _text32, _text33, _text34, _text35;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLlamaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    className: "bi bi-matrix-code",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 1,
    y: 2,
    fontFamily: "monospace",
    fontSize: 2
  }, "0")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 1,
    y: 4,
    fontFamily: "monospace",
    fontSize: 2
  }, "1")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 1,
    y: 6,
    fontFamily: "monospace",
    fontSize: 2
  }, "0")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 1,
    y: 8,
    fontFamily: "monospace",
    fontSize: 2
  }, "1")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 1,
    y: 10,
    fontFamily: "monospace",
    fontSize: 2
  }, "0")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 1,
    y: 12,
    fontFamily: "monospace",
    fontSize: 2
  }, "1")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 1,
    y: 14,
    fontFamily: "monospace",
    fontSize: 2
  }, "0")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 4,
    y: 1,
    fontFamily: "monospace",
    fontSize: 2
  }, "1")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 4,
    y: 3,
    fontFamily: "monospace",
    fontSize: 2
  }, "0")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 4,
    y: 5,
    fontFamily: "monospace",
    fontSize: 2
  }, "1")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 4,
    y: 7,
    fontFamily: "monospace",
    fontSize: 2
  }, "0")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 4,
    y: 9,
    fontFamily: "monospace",
    fontSize: 2
  }, "1")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 4,
    y: 11,
    fontFamily: "monospace",
    fontSize: 2
  }, "0")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 4,
    y: 13,
    fontFamily: "monospace",
    fontSize: 2
  }, "1")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 7,
    y: 2,
    fontFamily: "monospace",
    fontSize: 2
  }, "0")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 7,
    y: 4,
    fontFamily: "monospace",
    fontSize: 2
  }, "1")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 7,
    y: 6,
    fontFamily: "monospace",
    fontSize: 2
  }, "0")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 7,
    y: 8,
    fontFamily: "monospace",
    fontSize: 2
  }, "1")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 7,
    y: 10,
    fontFamily: "monospace",
    fontSize: 2
  }, "0")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 7,
    y: 12,
    fontFamily: "monospace",
    fontSize: 2
  }, "1")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 7,
    y: 14,
    fontFamily: "monospace",
    fontSize: 2
  }, "0")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 1,
    fontFamily: "monospace",
    fontSize: 2
  }, "1")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 3,
    fontFamily: "monospace",
    fontSize: 2
  }, "0")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 5,
    fontFamily: "monospace",
    fontSize: 2
  }, "1")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 7,
    fontFamily: "monospace",
    fontSize: 2
  }, "0")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 9,
    fontFamily: "monospace",
    fontSize: 2
  }, "1")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 11,
    fontFamily: "monospace",
    fontSize: 2
  }, "0")), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 13,
    fontFamily: "monospace",
    fontSize: 2
  }, "1")), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 13,
    y: 2,
    fontFamily: "monospace",
    fontSize: 2
  }, "0")), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 13,
    y: 4,
    fontFamily: "monospace",
    fontSize: 2
  }, "1")), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 13,
    y: 6,
    fontFamily: "monospace",
    fontSize: 2
  }, "0")), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 13,
    y: 8,
    fontFamily: "monospace",
    fontSize: 2
  }, "1")), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 13,
    y: 10,
    fontFamily: "monospace",
    fontSize: 2
  }, "0")), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    x: 13,
    y: 12,
    fontFamily: "monospace",
    fontSize: 2
  }, "1")), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    x: 13,
    y: 14,
    fontFamily: "monospace",
    fontSize: 2
  }, "0")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLlamaIcon);
export default __webpack_public_path__ + "static/media/llama-icon.0648c945cd049ac7496d9ec461007917.svg";
export { ForwardRef as ReactComponent };